import { useEffect } from 'react';

export interface IUseRegisterBackInterceptor {
  registerBackInterceptor(callback: () => boolean): void;

  unRegisterBackInterceptor(): void;

  prevStep(): boolean;
}

export const useRegisterBackInterceptor = ({
  registerBackInterceptor,
  prevStep,
  unRegisterBackInterceptor,
}: IUseRegisterBackInterceptor) => {
  useEffect(() => {
    registerBackInterceptor(prevStep);

    return () => unRegisterBackInterceptor();
  }, [registerBackInterceptor, unRegisterBackInterceptor, prevStep]);
};
